export default  {	
	data () {
		return { 

		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'basico_basico'}) 
	},
}
